import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { serverInfo } from "../../../../../../App";
import { LocationContext } from "../../../../../../CustomHelper/Helper";
import MyVerticallyCenteredModal from "../../../../../RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";
import PayAgain from "../../../../../RegisterLearningDetails/RegisterNowPay/PayAgain";
import Countdown from "react-countdown";
import ContdownTimerRender from "../../../../../../CustomHelper/ContdownTimerRender";
// import ChatHeadLock from "../../../../Pages/ChatHeadLock/ChatHeadLock";

const QnaActivity = ({
  event,
  singleEvent,
  event_type,
  openMessenger,
  setOpenMessenger,
  setEachChat,
}) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [qnaSessionRoom, setQnaSessionRoom] = useState("");
  const [payAgin, setPayAgin] = useState(false);
  const { paymentCount, paymentCountWithSymbol, payStatus, countryDateTime } =
    useContext(LocationContext);

  useEffect(() => {
    axios.get(`api/user/qna/reg_info/${event.id}`).then((res) => {
      if (res.data.status === 200) {
        setQnaSessionRoom(res.data.event);
      }
    });
  }, [event_type, event]);

  const event_start_time =
    moment(event?.event_date).format("LL") +
    " " +
    qnaSessionRoom?.qna_start_time;
  const event_end_time =
    moment(event?.event_date).format("LL") + " " + qnaSessionRoom?.qna_end_time;

  const event_start = new Date(countryDateTime(event_start_time, '')).getTime();
  const event_end = new Date(countryDateTime(event_end_time, '')).getTime();


  const joinChat = () => {
    if (payStatus) {

      setEachChat(singleEvent);
      setOpenMessenger([2, event.id]);

    } else {
      alert('please select your current country')
    }
  }

  return (
    <>
      {event_start >= new Date().getTime() ? (
        <div class="col-md-6 col-lg-4 mb-3">
          <div className="card text-center CardEn ">
            <img src={imageCdnUrl + event.banner} alt="Img1" className="ImgAc" />

            <div className="joinNowBgLive title_text_ellipsis">
              {event.title}
            </div>
            {!qnaSessionRoom.payment_status ? (
              <>
                <h6
                  className="fw-bold pt-3 pb-1 text-warning EnHeadLive"
                  onClick={() => setPayAgin(true)}
                >
                  <div class="spinner-grow text-warning" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>{" "}
                  Payment pending
                </h6>
              </>
            ) : (
              <h6
                className="fw-bold pt-3 pb-1 text-warning EnHeadLive"
                onClick={() => setOpenMessenger([1, event.id])}
              >
                Waiting
              </h6>
            )}

            {/* <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLive" onClick={() => setOpenMessenger([2,event.id])}>
              Join Now
            </h6> */}

            <Countdown
              date={event_start}
              renderer={ContdownTimerRender} />
          </div>
        </div>
      ) : event_start < new Date().getTime() &&
        event_end > new Date().getTime() ? (
        <div class="col-md-6 col-lg-4 mb-3">
          <div className="card text-center CardEnLive ">
            <img src={imageCdnUrl + event.banner} alt="Img1" className="ImgAc" />

            <div className="joinNowBg">Running...</div>

            <div className="joinNowBgLive title_text_ellipsis">
              {event.title}
            </div>
            {qnaSessionRoom.publish_status && (
              <h6
                className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive"
                onClick={() => joinChat()}
              >
                JOIN NOW
              </h6>
            )}
          </div>
        </div>
      ) : (
        <div class="col-md-6 col-lg-4 mb-3">
          <div className="card text-center CardEn">
            <img src={imageCdnUrl + event?.banner} alt="Img1" className="ImgAc" />

            <div className="joinNowBgLive title_text_ellipsis">
              {event.title}
            </div>

            <h6
              className="fw-bold pt-3 pb-1 text-danger EnHeadLive"
              onClick={() => {
                setEachChat(singleEvent);
                setOpenMessenger([2, event.id]);
              }}
            >
              Expired
            </h6>
          </div>
        </div>
      )}

      {/* <PayAgain
        show={payAgin}
        onHide={() => setPayAgin(false)}
        event_id={event.id}
        event_type={event_type}
        fee={event.fee}
      /> */}

      <MyVerticallyCenteredModal
        show={payAgin}
        onHide={() => setPayAgin(false)}
        event_id={event.id}
        event_type={event_type}
        redirectTo="activities"
        fee={paymentCount(event.fee)}
        baseFee={event.fee}
      />
    </>
  );
};

export default QnaActivity;
